import { useEffect, useState } from "react";
import AdminLayout from "@/components/AdminLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import api, { formatDetail } from "@/lib/api";

const DAYS = ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"];

export default function BusinessHoursPage() {
  const [hours, setHours] = useState([]);
  useEffect(() => { api.get("/admin/business-hours").then(({ data }) => setHours(data)); }, []);
  const save = async () => { try { await api.put("/admin/business-hours", hours); toast.success("Saved"); } catch (e) { toast.error(formatDetail(e.response?.data?.detail)); } };
  const update = (idx, key, val) => { const c = [...hours]; c[idx][key] = val; setHours(c); };
  return (
    <AdminLayout title="Business Hours" showTurnBoard={false}>
      <div className="bg-white rounded-2xl border border-zen-border overflow-hidden mb-6">
        {hours.map((h, i) => (
          <div key={h.day} className="flex items-center gap-4 p-4 border-b border-zen-border last:border-0" data-testid={`hour-row-${h.day}`}>
            <div className="w-32 font-medium">{DAYS[h.day]}</div>
            <Switch checked={!h.closed} onCheckedChange={(v) => update(i, "closed", !v)} data-testid={`hour-open-${h.day}`} />
            <span className="text-sm text-zen-muted w-16">{h.closed ? "Closed" : "Open"}</span>
            <Input type="time" value={h.open} onChange={(e) => update(i, "open", e.target.value)} disabled={h.closed} className="bg-zen-surface border-0 w-32" data-testid={`hour-from-${h.day}`} />
            <span>—</span>
            <Input type="time" value={h.close} onChange={(e) => update(i, "close", e.target.value)} disabled={h.closed} className="bg-zen-surface border-0 w-32" data-testid={`hour-to-${h.day}`} />
          </div>
        ))}
      </div>
      <Button onClick={save} className="rounded-full bg-zen-primary text-white" data-testid="hours-save-btn">Save Changes</Button>
    </AdminLayout>
  );
}
